import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, HostListener } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthTransmissionService } from '../../../services/raintree/Transmission/auth-transmission.service';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { AuthService } from '../../../services/auth/auth-service';
import { RequestMapper } from '../../../request-mapper';
import { RaintreeResponse } from '../../../services/raintree/interfaces/raintree-response';
import { AppConfigService } from '../../../services/config/app-config.service';

@Component({
  selector: 'app-login-email-auth-code',
  standalone: true,
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    MatAutocompleteModule,
    FormsModule,
  ],
  templateUrl: './login-email-auth-code.component.html',
  styleUrl: './login-email-auth-code.component.scss',
})
export class LoginEmailAuthCodeComponent {
  constructor(
    private _authTransmissionService: AuthTransmissionService,
    private snackbar: SnackbarService,
    private activateRoute: ActivatedRoute,
    private _commonUtilService: CommonUtilService,
    private _authService: AuthService,
    private _router: Router,
    private _apppConfig: AppConfigService
  ) {}
  authenticationCodeVisible = false;
  visibilityOnIcon = '--pass-visibility-on';
  visibilityOffIcon = '--pass-visibility-off';
  maskedNo: any;
  sessionId2: any;
  sessionId1: any;
  familyCode: any;
  phlMemCode: any;
  memName: any;
  memSurname: any;
  maskedEmail: any;
  sessionId: any;
  verifiedEmail: any;
  primaryEmail: any;
  loginFormPayload: any;
  loginVerifyForm = new FormGroup({
    authenticationCode: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
  });
 
  ngOnInit(): void {
    this.startCountdownForMobile();
    this.maskedEmail = localStorage.getItem('maskedEmail') || null;
    this.sessionId = localStorage.getItem('sessionId') || null;
    this.verifiedEmail = localStorage.getItem('verifiedEmail') || null;
    this.primaryEmail = localStorage.getItem('primaryEmail') || null;
    // if (
    //   !this.maskedEmail ||
    //   !this.sessionId ||
    //   !this.verifiedEmail ||
    //   !this.primaryEmail
    // ) {
    //   this._router.navigate(['/login']);
    // }
  }

  onInputBlur(field: string) {
    if (field === 'password') {
      this.authenticationCodeVisible =
        this.loginVerifyForm.controls.authenticationCode.invalid;
    }
  }
  toggleauthCodeVisibility() {
    this.authenticationCodeVisible = !this.authenticationCodeVisible;
  }
  isSpanDisabledForMobile = true;
  countdownForMobile = 180;
  countdownIntervalForMobile: any;
  mobilePayload: any;
  onResendForMobile(): void {
    this.resendMobileOtp();
    this.isSpanDisabledForMobile = true;
    this.countdownForMobile = 180; // Reset countdown
    this.startCountdownForMobile();
  }
  startCountdownForMobile(): void {
    this.countdownIntervalForMobile = setInterval(() => {
      if (this.countdownForMobile > 0) {
        this.countdownForMobile--;
      } else {
        this.isSpanDisabledForMobile = false;
        clearInterval(this.countdownIntervalForMobile);
      }
    }, 1000);
  }
  counter: number = 0;
  resendMobileOtp() {
    this.counter++;

    let loginFormPayload = {
      sessionId: this.sessionId,
      verifiedEmail: this.verifiedEmail,
    };

    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        this.sessionId = response['data'].sessionId; //latest added
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }

  requireFc: any;
  APIcall() {
    let loginFormPayload = {
      verifiedEmailSession: this.sessionId,
      otpValue: this.loginVerifyForm.get('authenticationCode')?.value,
      primaryEmail: this.primaryEmail,
    };

    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        if (
          this._commonUtilService.isValidObject(response) &&
          response.hasOwnProperty('data') &&
          this._commonUtilService.getValidData(response['data'].accessToken)
        ) {
          // SAVE Token and helping local strorage data
          this._authService.storeJwtTokenInLocalStorage(response['data']);

          // Redirect to landing page
          this._router.navigate([this._apppConfig.getLadingRoute()]);
        }
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
}
